import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { Tag } from "./StatusTag.styled";

const StatusTag = ({ status }) => { // replace Tag component in shop list and details with this comp.
  const statusMap = {
    DELIVERED: "Delivered",
    COMPLETED: "Completed",
    IN_TRANSIT: "In transit",
    ORDER_RECEIVED: "Order received",
  };

  const mapStatusTagStyles = (status) => {
    switch (status) {
      case statusMap.DELIVERED:
      case statusMap.ORDER_RECEIVED:
        return {
          dotColor: "#00A76A",
          backgroundColor: "#00A76A26",
        };
      case statusMap.COMPLETED:
        return {
          dotColor: "#217BBE",
          backgroundColor: "#217BBE26",
        };
      case statusMap.IN_TRANSIT:
        return {
          dotColor: "#FF9C00",
          backgroundColor: "#FF9C0026",
        };
      default:
        return {
          dotColor: "#217BBE",
          backgroundColor: "#217BBE26",
        };
    }
  };

  const tagStyles = useMemo(() => mapStatusTagStyles(status), []);

  return (
    <Tag backgroundColor={tagStyles.backgroundColor} dotColor={tagStyles.dotColor}>
      {status}
    </Tag>
  );
};

export default StatusTag;

StatusTag.propTypes = {
  status: PropTypes.string,
};
